import React from 'react';
import { useSelector } from 'react-redux';
import styles from './PriceBreakdown.module.scss';
import { subscriptionInfoSelector } from 'features/billing/subscription/subscriptionSlice';
import { pricesSelector } from 'features/billing/prices/pricesSlice';
import { upcomingInvoiceSelector } from 'features/billing/upcomingInvoice/upcomingInvoiceSlice';
import { currenciesListSelector } from 'features/currencies/currenciesSlice';

interface PriceBreakdownProps {
  newQuantity: number;
}

const PriceBreakdown: React.FC<PriceBreakdownProps> = ({ newQuantity }) => {
  const currencies = useSelector(currenciesListSelector)

  const subscriptionInfo = useSelector(subscriptionInfoSelector);
  const prices = useSelector(pricesSelector);
  const upcomingInvoice = useSelector(upcomingInvoiceSelector);

  const currentPrice = prices.find(price => price.id === subscriptionInfo!.priceId);
  const getCurrencySymbol = (currencyCode: string) => currencies.find(x => x.code.toLowerCase() === currencyCode.toLowerCase())?.symbol ?? currencyCode

  return (
    <div className={styles.subscriptionDetails}>
      <div className={styles.spaceBetween}>
        <p>Current plan</p>
        <p>{subscriptionInfo!.interval === 'month' ? 'Monthly' : 'Annual'} billing</p>
      </div>
      <p className={styles.title}>
        <span className={styles.currentPlan}>{subscriptionInfo!.name}</span>
      </p>
      <hr />
      <div className={styles.spaceBetween}>
        <p>
          Subscription seats: {newQuantity - subscriptionInfo!.quantity} x {getCurrencySymbol(currentPrice!.currency)}{currentPrice!.amount}
        </p>
        <p>
          {getCurrencySymbol(subscriptionInfo!.currency)}
          {((newQuantity - subscriptionInfo!.quantity) * (currentPrice?.amount ?? 0)).toFixed(2)}
        </p>
      </div>
      <hr />
      <div className={styles.spaceBetween}>
        <div>
          <p>Subtotal</p>
          <p>Reflects adjusted price for remaining time on your current plan.</p>
        </div>
        <p>{upcomingInvoice.subtotal}</p>
      </div>
      <hr />
      <div className={styles.spaceBetween}>
        <p>VAT</p>
        <p>{upcomingInvoice.tax}</p>
      </div>
      <hr />
      <div className={styles.spaceBetween}>
        <p>Applied balance</p>
        <p>{(upcomingInvoice.startingBalance - upcomingInvoice.endingBalance).toFixed(2)}</p>
      </div>
      <div className={`${styles.spaceBetween} ${styles.planSummary}`}>
        <div>
          <p>Total due today</p>
          <p>Estimated prorated price for this change.</p>
        </div>
        <p className={styles.totalPrice}>{upcomingInvoice.amountDue}</p>
      </div>
    </div>
  );
};

export default PriceBreakdown;
